<template>
  <div>
    <div class="columns is-desktop">
      <div class="column is-2">
        <div
          class="is-flex is-justify-content-space-between is-align-items-center"
        >
          <button
            style="width: 10%"
            class="button is-light is-small mr-2"
            v-show="isMobileView"
            @click="handleViewOnMobileMenu"
          >
            <i
              :class="
                !showMenuMobile ? 'fa fa-chevron-down' : 'fa fa-chevron-up'
              "
            ></i>
          </button>
          <Dropdown
            name="category"
            :Title="
              filterItems.category && classDataSource.data.length
                ? classDataSource.data.find(
                    (x) => x.value == filterItems.category
                  ).label
                : 'Select Class'
            "
            :style="!isMobileView ? 'width: 100%' : 'width: 60%'"
            :dataSource="classDataSource.data"
            :value="filterItems.category"
            :change="handleDropdownChange"
            :loading="disable"
          />
          <button
            style="width: 25%"
            v-show="isMobileView"
            class="button is-primary is-small ml-2"
            @click="fetchingData"
          >
            Generate
          </button>
        </div>
      </div>
      <div class="column is-2" v-show="!isMobileView || showMenuMobile">
        <Dropdown
          name="item"
          :Title="
            filterItems.item && itemDataSource.data.length
              ? itemDataSource.data.find((x) => x.value == filterItems.item)
                  .label
              : 'Select Item'
          "
          :dataSource="itemDataSource.data"
          :value="filterItems.item"
          :change="handleDropdownChange"
          :loading="disable"
        />
      </div>
      <div class="column is-2" v-show="!isMobileView || showMenuMobile">
        <DropdownSelection
          name="behaviorID"
          :Title="
            filterItems.item == 1
              ? `Choose Items (${filterItems.behaviorID.length}/${behaviorDataSource.data.length})`
              : `Choose Category`
          "
          :dataSource="behaviorDataSource.data"
          :value="filterItems.behaviorID"
          :change="handleDropdownChange"
          :type="filterItems.item"
          :handleUpdate="handleUpdate"
          :loading="disable"
          :showLoader="behaviorDataSource.loading"
          :showModalBehavior="showModalBehavior"
        />
      </div>
      <div class="column is-2" v-show="!isMobileView || showMenuMobile">
        <Dropdown
          name="duration"
          :Title="
            filterItems.duration && durationDataSource.data.length
              ? durationDataSource.data.find(
                  (x) => x.value == filterItems.duration
                ).label
              : 'Select Duration'
          "
          :dataSource="durationDataSource.data"
          :value="filterItems.duration"
          :change="handleDropdownChange"
          :loading="disable"
        />
      </div>
      <div
        class="column is-2"
        v-show="!isMobileView || showMenuMobile"
        v-if="filterItems.duration == 1"
      >
        <Dropdown
          name="month"
          :Title="
            filterItems.month && monthDataSource.data.length
              ? monthDataSource.data.find((x) => x.value == filterItems.month)
                  .label
              : 'Select Month'
          "
          :dataSource="monthDataSource.data"
          :value="filterItems.month"
          :change="handleDropdownChange"
          :loading="disable"
        />
      </div>
      <div
        class="column is-2"
        v-show="!isMobileView || showMenuMobile"
        v-if="filterItems.duration == 2"
      >
        <Dropdown
          name="year"
          :Title="
            filterItems.year && yearDataSource.data.length
              ? yearDataSource.data.find((x) => x.value == filterItems.year)
                  .label
              : 'Select Year'
          "
          :dataSource="yearDataSource.data"
          :value="filterItems.year"
          :change="handleDropdownChange"
          :loading="disable"
        />
      </div>
      <div
        class="column is-2"
        v-show="!isMobileView || showMenuMobile"
        v-if="filterItems.duration == 3"
      >
        <InputCalender
          :value="filterItems.range"
          :change="handleDropdownChange"
          :type="'range'"
          :showMenuMobile="showMenuMobile"
          :loading="disable"
        />
      </div>
      <div
        class="column is-2"
        v-show="!isMobileView || showMenuMobile"
        v-if="filterItems.duration == 4"
      >
        <InputCalender
          :value="selectedDaily"
          :change="handleDropdownChange"
          :type="'day'"
          :showMenuMobile="showMenuMobile"
          :loading="disable"
        />
      </div>
      <div class="column is-2" v-show="filterItems.duration == 5"></div>
      <div class="column is-2" v-show="!isMobileView">
        <button
          :disabled="behaviorDataSource.loading || disable"
          :class="disable && 'is-loading'"
          class="button is-primary is-small full-width"
          @click="fetchingData"
        >
          Generate
        </button>
      </div>
    </div>
  </div>
  <!-- <div>
    <div
      :class="
        !showMenuMobile
          ? 'is-flex is-justify-content-space-between is-align-items-center is-close-menu'
          : 'is-active-menu'
      "
    >
      <Dropdown
        name="category"
        :Title="
          filterItems.category && classDataSource.data.length
            ? classDataSource.data.find((x) => x.value == filterItems.category)
                .label
            : 'Select Class'
        "
        :style="!showMenuMobile ? isWidthResize : isMobileSize"
        :dataSource="classDataSource.data"
        :value="filterItems.category"
        :change="handleDropdownChange"
        :loading="disable"
      />
      <Dropdown
        name="item"
        :Title="
          filterItems.item && itemDataSource.data.length
            ? itemDataSource.data.find((x) => x.value == filterItems.item).label
            : 'Select Item'
        "
        :style="!showMenuMobile ? isWidthResize : isMobileSize"
        :dataSource="itemDataSource.data"
        :value="filterItems.item"
        :change="handleDropdownChange"
        :loading="disable"
      />
      <DropdownSelection
        name="behaviorID"
        :Title="
          filterItems.item == 1
            ? `Choose Items (${filterItems.behaviorID.length}/${behaviorDataSource.data.length})`
            : `Choose Category`
        "
        v-show="!isMobileView || showMenuMobile"
        :style="!showMenuMobile ? isWidthResize : isMobileSize"
        :dataSource="behaviorDataSource.data"
        :value="filterItems.behaviorID"
        :change="handleDropdownChange"
        :type="filterItems.item"
        :handleUpdate="handleUpdate"
        :loading="disable"
      />
      <Dropdown
        name="duration"
        :Title="
          filterItems.duration && durationDataSource.data.length
            ? durationDataSource.data.find(
                (x) => x.value == filterItems.duration
              ).label
            : 'Select Duration'
        "
        v-show="!isMobileView || showMenuMobile"
        :style="!showMenuMobile ? isWidthResize : isMobileSize"
        :dataSource="durationDataSource.data"
        :value="filterItems.duration"
        :change="handleDropdownChange"
        :loading="disable"
      />
      <Dropdown
        v-if="filterItems.duration == 1"
        name="month"
        :Title="
          filterItems.month && monthDataSource.data.length
            ? monthDataSource.data.find((x) => x.value == filterItems.month)
                .label
            : 'Select Month'
        "
        v-show="(!isMobileView && filterItems.duration == 1) || showMenuMobile"
        :style="!showMenuMobile ? isWidthResize : isMobileSize"
        :dataSource="monthDataSource.data"
        :value="filterItems.month"
        :change="handleDropdownChange"
        :loading="disable"
      />
      <Dropdown
        v-if="filterItems.duration == 2"
        name="Year"
        :Title="
          filterItems.year && yearDataSource.data.length
            ? yearDataSource.data.find((x) => x.value == filterItems.year).label
            : 'Select Year'
        "
        v-show="(!isMobileView && filterItems.duration == 2) || showMenuMobile"
        :style="!showMenuMobile ? isWidthResize : isMobileSize"
        :dataSource="yearDataSource.data"
        :value="filterItems.year"
        :change="handleDropdownChange"
        :loading="disable"
      />
      <InputCalender
        v-if="filterItems.duration == 3"
        :style="isMobileView ? 'width: 100%' : 'width: calc(100% / 8)'"
        v-show="(!isMobileView && filterItems.duration == 3) || showMenuMobile"
        :value="filterItems.range"
        :change="handleDropdownChange"
        :type="'range'"
        :showMenuMobile="showMenuMobile"
        :loading="disable"
      />
      <InputCalender
        v-if="filterItems.duration == 4"
        :style="isMobileView ? 'width: 100%' : 'width: calc(100% / 8)'"
        v-show="(!isMobileView && filterItems.duration == 4) || showMenuMobile"
        :value="selectedDaily"
        :change="handleDropdownChange"
        :type="'day'"
        :showMenuMobile="showMenuMobile"
        :loading="disable"
      />
      <button
        v-show="isMobileView"
        class="button mt-4 mb-4 is-small"
        :class="!showMenuMobile ? 'is-primary' : 'is-light'"
        :style="!showMenuMobile ? isWidthResize : isMobileSize"
        @click="handleViewOnMobileMenu"
      >
        {{ !showMenuMobile ? "Filter" : "Close" }}
      </button>
      <button
        :style="isMobileView ? 'width: 100%' : 'width: calc(100% / 8)'"
        v-show="!isMobileView || showMenuMobile"
        class="button is-primary is-small"
        @click="fetchingData"
      >
        Generate
      </button>
    </div>
  </div> -->
</template>

<script>
import Dropdown from "./Dropdown.vue";
import DropdownSelection from "./DropdownSelection";
import InputCalender from "./InputCalender.vue";
export default {
  name: "Filters",
  components: { Dropdown, InputCalender, DropdownSelection },
  props: [
    "fetchingData",
    "classDataSource",
    "filterItems",
    "itemDataSource",
    "handleDropdownChange",
    "behaviorDataSource",
    "durationDataSource",
    "monthDataSource",
    "yearDataSource",
    "handleUpdate",
    "disable",
    "showModalBehavior",
  ],
  data() {
    return {
      showMenuMobile: false,
      isMobileView: false,
      isWidthResize: "width: calc(100% / 8)",
      isMobileSize: "width: 100%; margin-bottom: 8px",
      windowWidth: window.innerWidth,
      selectedDaily: this.filterItems.daily,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  watch: {
    filterItems() {
      this.selectedDaily = this.filterItems.daily;
    },
    windowWidth(newWidth, oldHeight) {
      if (newWidth <= 420) {
        this.isMobileView = true;
        this.isWidthResize = "width: calc(100% / 3 - 1%)";
      } else if (newWidth >= 420 && newWidth <= 768) {
        this.isMobileView = true;
        this.isWidthResize = "width: calc(100% / 3 - 1%)";
      } else {
        this.isMobileView = false;
        this.isWidthResize = "width: calc(100% / 5 - 1%)";
      }
    },
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    handleViewOnMobileMenu() {
      this.showMenuMobile = !this.showMenuMobile;
    },
  },
};
</script>

<style>
.auto-width {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.is-close-menu {
  height: 0;
  transition: ease 300ms;
}

.is-active-menu {
  height: 100%;
  /* max-height: 400px; */
  transition: ease 300ms;
}
</style>


// WEBPACK FOOTER //
// src/components/OverallReporting/Filters.vue